'use client'

import useFutures from '@/hook/wallet/useFutures'
import { storeInsTicker } from '@/stores/ins/ticker'
import { storeBinanceSpotTicker } from '@/stores/spot/ticker'
import { useEffect } from 'react'

export const WsProvider = ({ children }: { children: React.ReactNode }) => {
  const { spotWsInit, insWsInit } = {
    // 바이낸스 웹소켓
    spotWsInit: storeBinanceSpotTicker((s) => s.wsInit),
    // Ins 웹소켓
    insWsInit: storeInsTicker((s) => s.wsInit),
  }

  useFutures()

  useEffect(() => {
    spotWsInit()
    insWsInit()
  }, [])
  return <>{children}</>
}
